<template>
  <div class="page-footer-container" v-if="!isDetailOn">
    <div class="footer__inner">
      <template v-if="$bowser.mobile">
        <p>© WJID Interior Aarchitecture Design. 维几设计 版权所有</p>
        <p>
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
            >沪ICP备19026272号-1</a
          >
        </p>
      </template>
      <template v-else>
        <p>
          © WJID Interior Aarchitecture Design. 维几设计 网站版权所有 |
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
            >沪ICP备19026272号-1</a
          >
        </p>
        <p>
          <a style="color: inherit;" href="https://www.gooob.cn/" target="_blank"
            >Web Design: Gooobrand</a
          >
        </p>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'c__page-footer',
  data() {
    return {
      isDetailOn: false,
    };
  },
  mounted() {
    this.$root.$on('detailOn', () => {
      this.isDetailOn = true;
    });
    this.$root.$on('detailOff', () => {
      this.isDetailOn = false;
    });
  },
};
</script>

<style></style>
